/* Returned Parcels — return value per month (by return date): Σ qty × invoiced unit price. */
import { useEffect, useState } from "react";
import axios from "axios";
import { API, getAuthHeader } from "@/App";

export const ReturnValueStrip = () => {
  const [months, setMonths] = useState(null);
  useEffect(() => {
    axios.get(`${API}/returned-parcels/value-summary`, { headers: getAuthHeader(), params: { months: 6 } })
      .then((r) => setMonths(r.data.months)).catch(() => setMonths([]));
  }, []);
  if (!months?.length) return null;
  const label = (m) => new Date(`${m}-01T00:00:00`).toLocaleString("en-IN", { month: "short", year: "numeric" });
  return (
    <div className="flex flex-wrap items-stretch gap-2 mb-2" data-testid="rp-value-strip">
      <span className="self-center text-[11px] font-semibold text-slate-600">Return value by month:</span>
      {months.map((b) => (
        <div key={b.month} className="rounded border border-slate-200 bg-white px-2.5 py-1 text-[11px]" data-testid={`rp-value-month-${b.month}`}
             title={`${b.valued} of ${b.parcels} parcels priced${b.partial ? ` · ${b.partial} partial` : ""}`}>
          <div className="font-semibold text-slate-700">{label(b.month)} <span className="font-normal text-slate-400">· {b.parcels} parcels</span></div>
          {b.valued ? (
            <div><b>₹{b.value_inr.toLocaleString("en-IN")}</b> <span className="text-emerald-700">${b.value_usd.toLocaleString("en-US")}</span>
              {(b.partial > 0 || b.valued < b.parcels) && <span className="ml-1 text-[9px] font-bold text-amber-700">partial</span>}</div>
          ) : <div className="text-slate-400">no prices</div>}
        </div>
      ))}
    </div>
  );
};
